import fetchApi from "../fetch-api";
import * as t from "io-ts";
type FilterT = {
  metadata: Record<string, any>;
  name: string;
  userID: string;
  userName: string;
};


export const saveSearchFilter = (filterObject: FilterT) => {
  return fetchApi({
    service: "core-service",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    pathname: `/save-search-filter`,
    codec: t.any,
    body: filterObject,
  });
};